// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Input style */
.input-search-with-button__input input{
    /* background: transparent;
    width: 100%;
    border-style: none;
    font-family: var(--primary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc( var(--space) + 1px );
    line-height: calc( var(--space-and-half) - 2px );;
    display: flex;
    align-items: center;
    letter-spacing: 0.001em; */
    color: var(--primary-dark-color);
}

.input-search-with-button__input.MuiFormControl-root .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: none;
}

.input-search-with-button__input.MuiFormControl-root .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
    border: none;
}

.input-search-with-button__input.MuiFormControl-root .MuiOutlinedInput-root{
    color: var(--basic-gray-color);
    padding: 12px 10px;
}

.input-search-with-button__input.MuiFormControl-root .MuiOutlinedInput-root span {
    font-size: var(--space-and-half);
    margin-right: var(--space-half);
}

.input-search-with-button__input.MuiFormControl-root .MuiOutlinedInput-root .MuiOutlinedInput-input {
    padding: 0;
}

.input-search-with-button__input {
    width: 330px;
    background: var(--new-background-color);
    border-radius: 8px 0px 0px 8px;
}

.input-search-with-button__icon.MuiButtonBase-root.MuiIconButton-root {
    border-radius: 0 8px 8px 0;
    padding: 12px 12px;
    background-color: var(--new-green-color);
}

.input-search-with-button__icon.MuiButtonBase-root.MuiIconButton-root .MuiSvgIcon-root {
    fill: var(--white-color);
}`, "",{"version":3,"sources":["webpack://./src/shared/components/input-search-with-button/InputSearchWithButtonComponent.styles.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI;;;;;;;;;;8BAU0B;IAC1B,gCAAgC;AACpC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,+BAA+B;AACnC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,uCAAuC;IACvC,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,wBAAwB;AAC5B","sourcesContent":["/*Input style */\n.input-search-with-button__input input{\n    /* background: transparent;\n    width: 100%;\n    border-style: none;\n    font-family: var(--primary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc( var(--space) + 1px );\n    line-height: calc( var(--space-and-half) - 2px );;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.001em; */\n    color: var(--primary-dark-color);\n}\n\n.input-search-with-button__input.MuiFormControl-root .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {\n    border: none;\n}\n\n.input-search-with-button__input.MuiFormControl-root .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {\n    border: none;\n}\n\n.input-search-with-button__input.MuiFormControl-root .MuiOutlinedInput-root{\n    color: var(--basic-gray-color);\n    padding: 12px 10px;\n}\n\n.input-search-with-button__input.MuiFormControl-root .MuiOutlinedInput-root span {\n    font-size: var(--space-and-half);\n    margin-right: var(--space-half);\n}\n\n.input-search-with-button__input.MuiFormControl-root .MuiOutlinedInput-root .MuiOutlinedInput-input {\n    padding: 0;\n}\n\n.input-search-with-button__input {\n    width: 330px;\n    background: var(--new-background-color);\n    border-radius: 8px 0px 0px 8px;\n}\n\n.input-search-with-button__icon.MuiButtonBase-root.MuiIconButton-root {\n    border-radius: 0 8px 8px 0;\n    padding: 12px 12px;\n    background-color: var(--new-green-color);\n}\n\n.input-search-with-button__icon.MuiButtonBase-root.MuiIconButton-root .MuiSvgIcon-root {\n    fill: var(--white-color);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
